<template>
    <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <a role="button" class="navbar-burger" data-target="navMenu" aria-label="menu" aria-expanded="false">
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
        </div>
        <div class="navbar-menu" id="navMenu">

            <div class="nav-left is-pulled-left is-flex" :class="{'is-active': isActive }">
                <router-link v-for="item in menuLeftItems" :key="item.title" :to="item.link" class="navbar-item" exact>
                    <span class="icon">
                        <i class="fa" :class="item.icon"></i>
                    </span> {{ item.title }}
                </router-link>
                <router-link to="/galerija" class="navbar-item" exact @click.native="clearGallery()">
                    <span class="icon">
                        <i class="fa fa-picture"></i>
                    </span> Galerija
                </router-link>
            </div>
            <div v-if="menu" class="nav-right is-pulled-right navbar-end">
                <!-- locations -->
                <div class="dropdown is-hoverable">
                    <div class="rel">
                        <router-link to="/" class="navbar-link" aria-haspopup="true" aria-controls="dropdown-menu4">
                            Lokacije
                            <span class="icon is-small"></span>
                        </router-link>
                    </div>
                    <div class="dropdown-menu" id="dropdown-menu4" role="menu">
                        <div class="dropdown-content">
                            <router-link  v-for="menuItem in menu.locations" :key="menuItem.title" :to="{name: 'Location', params: {location: menuItem.slug}}" class="dropdown-item">
                                {{ menuItem.name | capitalize }}
                            </router-link>
                        </div>
                    </div>
                </div>
                <!-- moje živalce -->
                <div class="dropdown is-hoverable">
                    <div class="rel">
                        <router-link to="/" class="navbar-link" aria-haspopup="true" aria-controls="dropdown-menu4">
                            MOJE ŽIVALCE
                            <span class="icon is-small"></span>
                        </router-link>
                    </div>
                    <div class="dropdown-menu" id="dropdown-menu4" role="menu">
                        <div class="dropdown-content">
                            <router-link  v-for="menuItem in menu.albums" :key="menuItem.name" :to="'/' + menuItem.slug" class="dropdown-item" >
                                {{ menuItem.name | capitalize }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </nav>
</template>
<script>
import StringsMixin from '../../mixins/StringsMixin';
// Hamburger menu
document.addEventListener('DOMContentLoaded', function () {

  // Get all "navbar-burger" elements
  var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {

    // Add a click event on each of them
    $navbarBurgers.forEach(function ($el) {
      $el.addEventListener('click', function () {

        // Get the target from the "data-target" attribute
        var target = $el.dataset.target;
        var $target = document.getElementById(target);

        // Toggle the class on both the "navbar-burger" and the "navbar-menu"
        $el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

      });
    });
  }

});
// import Tooltip from 'vue-bulma-tooltip';
import { mapGetters } from 'vuex';
// import Swipper from '../elements/swipper/Swipper';
import { ApiHome } from '../../.env';
import Gmaps from '../elements/gmaps/GoogleMaps';

export default {
    name: 'app-navbar',
    mixins: [ StringsMixin],
    components: {
        // 'app-swipper': Swipper
    },

    // On route change, not on reload
    watch: {
        '$route' (to, from) {
            console.log('wathc: ', to.name);
            this.$router.go(to.name);
        }
    },
    data() {
        return {
            isActive: false,
            endpoint: ApiHome,
            // set to T if is should be on the home page
            showSwipper: true,
            image: ''
        };
    },

    computed: {
        ...mapGetters([
            'swipping',
            'menu',
            'error',
            'albumLocation'
        ]),
        menuLeftItems() {

            let menuLeftItems = [
                { icon: 'fa-home', title: '', name: 'Domov', link: '/', swipper: true },
                { icon: '', title: 'O nas', name: 'O nas', link: '/o-nas', swipper: false },
                { icon: '', title: 'Kontakt', name: 'Kontakt', link: '/kontakt', swipper: false },
                { icon: '', title: 'Blog', name: 'Blog', link: '/blog', swipper: false },
            ];

            return menuLeftItems;
        },

    },

    methods: {
        // Control on which pages swipper will be visible
        // (main pages: about, contact, ..)
        // not needed - we manage with route watch
        getMenu() {
            // console.log('items menu? ', this.albumLocation);
            this.$store.dispatch('fetchMenu', this.endpoint + 'menu');
        },

        clearGallery() {
            let elem = document.getElementById('searchField');
            // console.log('elem: ', elem);
            if(typeof elem !== undefined && elem !== null) {
                if(elem.hasOwnProperty('value')) {
                    elem.value = '';
                }
                this.$store.dispatch('fetchGallery', this.endpoint + 'gallery');
            }
        },
        // On click event for album dropdown
        sendItem(name) {
            // refactor - same functionality click event for specific album
            // on Album.vue
            // console.log('fetch album from navbar.vue');
            this.$store.dispatch('fetchAlbum', this.endpoint + 'album/' + name)
                .then(() => {
                    console.log('Started fetching item: ', this.endpoint, this.item);
                    // console.log('fetching list of items: ');
                    if(this.error === null) {
                        this.album = true;
                        console.log('Error is null: ', this.loading);
                    }
                })
        },

        // On click event for location dropdown
        sendItemLocation(menuItem) {
            const element = document.getElementById('google-map');
            if(element !== null) {
                let opt = {
                    lat: menuItem.lat,
                    lng: menuItem.lng,
                    zoom: 5,
                    name: menuItem.name
                }
                console.log('navbar elem: ', element);
                let gmaps = new Gmaps(opt);
                gmaps.drawMap();
            }
            // refactor - same functionality click event for specific album
            // on Album.vue
            // console.log('fetch album from navbar.vue ', menuItem.slug);
            this.$store.dispatch('fetchLocation', this.endpoint + 'location/' + menuItem.slug)
                .then(() => {
                    // console.log('Started fetching location from navbar: ', this.endpoint, menuItem.name);
                    // console.log('fetching list of items: ');
                    if(this.error === null) {
                        // console.log('Error is null');
                    }

                    if(this.location !== null) {
                        // console.log('Location available: ', menuItem.lat, menuItem.lng, menuItem.name);
                        // Rewrite map if elem is available
                        const element = document.getElementById('google-map');
                        if(element !== null) {
                            let opt = {
                                lat: menuItem.lat,
                                lng: menuItem.lng,
                                zoom: 5,
                                name: menuItem.name
                            }
                            // console.log('navbar elem: ', element);
                            let gmaps = new Gmaps(opt);
                            gmaps.drawMap();
                        }
                        // this.$store.dispatch('fetchPhotosLocation', this.endpoint);
                    }
                })
        }
    },
    created() {
        this.showSwipper = this.swipping;
        this.getMenu();
    }
}

</script>




// WEBPACK FOOTER //
// src/components/layout/Navbar.vue